// UserGroupFilterDrawer - MODULE
// ***********************************************************************************************************************
import { Grid, MenuItem, Select } from "@mui/material";
import * as React from "react";
import { DrawerContent } from "source/components/framework/Drawer/DrawerContent";
import { FilterButtons } from "source/components/framework/Filters/FilterButtons";
import { FilterSearchField } from "source/components/framework/Filters/FilterSearchField";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { IListFilterItem } from "../../../models/common/listFilterItem";
import { GridRow } from "../../framework/Grid/GridRow";
import { PageFilterConditionDrawer } from "../../framework/Page/PageFilterConditionDrawer";

//UserGroupFilterDrawer
export interface IUserGroupFilterDrawerProp {
    open: boolean;
    classes?: string;
    filter: IListFilterItem;
    authorizationLevelFilters: IIdTitle[];
    authorizationLevelId: string;
    canRemoveSharedFilters: boolean;
    onSaveFilter: (saveAs: boolean, onGetGeneralFilter: () => any) => void;
    onRemoveFilter: (filterId: string) => void;
    onOk: (closeDrawer: boolean, authorizationLevelId: string) => any;
    onCancel: () => void;
}

export interface IUserGroupFilterDrawerState {
    authorizationLevelId: string;
}

export class UserGroupFilterDrawer extends React.Component<IUserGroupFilterDrawerProp, IUserGroupFilterDrawerState> {
    private orgStateHash: string = "";

    getStateFromProps = (props: IUserGroupFilterDrawerProp): IUserGroupFilterDrawerState => {
        return {
            authorizationLevelId: props.authorizationLevelId
        };
    };

    constructor(props: IUserGroupFilterDrawerProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        this.orgStateHash = this.getSaveDataFromState(props, this.state).hash;
    }

    componentDidUpdate(prevProps: IUserGroupFilterDrawerProp, prevState: IUserGroupFilterDrawerState): void {
        const props = this.props;
        if (!prevProps || prevProps?.filter?.getHash() === props?.filter?.getHash()) return;
        const state = this.getStateFromProps(props);
        this.setState(state);
        this.orgStateHash = this.getSaveDataFromState(props, state).hash;
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "authorizationLevelId") {
            this.setState({ authorizationLevelId: value });
        }
    };

    getSaveDataFromState = (props: IUserGroupFilterDrawerProp, state: IUserGroupFilterDrawerState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("authorizationLevelId", state.authorizationLevelId ? state.authorizationLevelId : null);
        return result;
    };
    
    static filterIsSet = (authorizationLevelFilters: IIdTitle[],
        selectedAuthorizationLevelId: string): boolean => {
        if (authorizationLevelFilters.length < 1) return false;
        return !(selectedAuthorizationLevelId === authorizationLevelFilters[0].id);
    };

    handleSaveFilter = async (saveAs: boolean) => {
        const props = this.props;
        const state = this.state;
        if (!saveAs) {
            props.onOk(false, state.authorizationLevelId);
            await this.props.onSaveFilter(false, null);
        } else {
            await this.props.onSaveFilter(true, () => {
                return props.onOk(false, state.authorizationLevelId);
            });
        }
    };

    handleClear = () => {
        const props = this.props;
        this.setState({
            authorizationLevelId: props.authorizationLevelFilters[0].id
        });
    };

    handleSave = async () => {
        const props = this.props;
        const state = this.state;
        props.onOk(true, state.authorizationLevelId);
    };

    handleCancel = async (checkChanges: boolean) => {
        AppUtils.cancelEditDialog(checkChanges, this.getSaveDataFromState(this.props, this.state).hash, this.orgStateHash, this.handleSave, this.props.onCancel, Translations.YouHaveUnapprovedChangesDoYouWantApproveChanges);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageFilterConditionDrawer
                open={props.open}
                onClose={() => this.handleCancel(false)}
            >
                <DrawerContent
                    content={
                        <>
                            <FilterSearchField
                                filter={props.filter}
                                canRemoveSharedFilters={props.canRemoveSharedFilters}
                                onSaveFilter={this.handleSaveFilter}
                                onRemoveFilter={props.onRemoveFilter}
                            />
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.AuthorizationLevel}>
                                        <Select name="authorizationLevelId" title={Translations.AuthorizationLevel} value={state.authorizationLevelId} onChange={this.handleChange}>
                                            {props.authorizationLevelFilters.map(authorizationLevelFilter =>
                                                <MenuItem key={authorizationLevelFilter.id} value={authorizationLevelFilter.id}>{authorizationLevelFilter.title}</MenuItem>
                                            )}
                                        </Select>
                                    </FormField>
                                </Grid>
                            </GridRow>
                        </>
                    }
                    actions={
                        <FilterButtons onSave={this.handleSave} onCancel={() => this.handleCancel(false)} onClear={this.handleClear} />
                    }
                />
            </PageFilterConditionDrawer>
        );
    }
}